-<style src='@/resources/styles/loading.css' scoped></style>

<template>
  <main>
    <div class='inner cover'>
      <div class='loader'>
        <div class='toHide'>
          <h1 id='status' class='status lead'>
            Generating...
          </h1>

          <p class="status">
            Keywords: <strong>{{ seedsString }}</strong>
          </p>

          <Spinner />
          <div class='state'>{{ loadingStatus }}</div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

  import {mapActions, mapGetters} from 'vuex'
  import States from "../../../States"
  import Spinner from "../../extended/Spinner";

  export default {
    name: 'GeneratingView',
    components: {Spinner},
    mounted: function() {
      const state = this.$store.getters.state;

      if (state !== States.GENERATING) {
        window.console.warn(`State NOT  ${States.GENERATING} : ${state}`);
        this.$router.push("/");
      } else
        this.pageLoaded(this.$route);
    },

    beforeRouteLeave(to,from,next) {
      const loadingStatus =  this.$store.getters.loadingStatus;
      if (this.$store.getters.state === States.GENERATING && typeof loadingStatus !== "undefined" && loadingStatus.length > 0) {
        //generation not yet finished
        window.console.log("Cancelling navigation", this.$store.getters.state, loadingStatus);
        this.$store.dispatch("showTempError", "You'll be back - after your generation finishes. Please wait..");
        next(false);
      } else
        next();
    },

    computed: {

      ...mapGetters(['state', "loadingStatus", "loadingProgress", "seeds"]),

      seedsString() {
        return this.seeds.join(", ")
      },
    },

    methods: {

      ...mapActions(['pageLoaded'])
    }
  }
</script>